module.exports = __webpack_public_path__ + "img/miniProgramCode.8e185be9.jpg";